import "core-js/modules/es.number.constructor.js";
export default defineComponent({
  name: 'RankList3Levels',
  props: {
    rank: {
      type: Number,
      default: 0
    },
    isWhite: {
      type: Boolean,
      default: false
    },
    isGray: {
      type: Boolean,
      default: false
    },
    isBrown: {
      type: Boolean,
      default: false
    },
    rankLevel: {
      type: Number,
      default: 3
    }
  },
  setup: function setup(props) {
    var blockToDisplay = props.rankLevel;
    var filledBlocksToDisplay = props.rank;
    var unfilledBlockToDisplay = blockToDisplay - props.rank;
    return {
      filledBlocksToDisplay: filledBlocksToDisplay,
      unfilledBlockToDisplay: unfilledBlockToDisplay
    };
  }
});